import React, { FC } from 'react'

import { IconSimSwapProps } from './IconSimSwap.types'
import * as Styled from './styles/IconSimSwap.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSimSwap: FC<IconSimSwapProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSimSwapProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSimSwapProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M66 64H46a10 10 0 0 0-10 10v32a10 10 0 0 0 10 10h20a10 10 0 0 0 10-10V74a10 10 0 0 0-10-10zm2 42a2 2 0 0 1-2 2H46a2 2 0 0 1-2-2V74a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2z' />
        <path d='m139.31 44.69-16-16A15.9 15.9 0 0 0 112 24H86.62L75.31 12.69A15.9 15.9 0 0 0 64 8H32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16V56a15.89 15.89 0 0 0-4.69-11.31zM96 88h18a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2H95.47a15.92 15.92 0 0 0 .53-4zm-64 40a8 8 0 0 1-8-8V24a8 8 0 0 1 8-8h32a8 8 0 0 1 5.66 2.35l16 16A8 8 0 0 1 88 40v80a7.94 7.94 0 0 1-1.07 4 4 4 0 0 0-.48.74A8 8 0 0 1 80 128zm104 8a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8h8a15.93 15.93 0 0 0 11-4.44 9.84 9.84 0 0 0 2.87.44H114a10 10 0 0 0 10-10V90a10 10 0 0 0-10-10H96V40a15.89 15.89 0 0 0-2.16-8H112a8 8 0 0 1 5.66 2.35l16 16A8 8 0 0 1 136 56z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSimSwap
